export default __webpack_public_path__ + "static/Efficacy-TSAT-Changes-chart-SM@2x-4bdfc650983afcf28f95303627013ea5.png";